export default {
  totalPages: state => {
    return Math.ceil(state.employeesCount / state.limit)
  },
  currentPage: state => {
    return Math.ceil(state.skip / state.limit + 1)
  }
}
